/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropparticipationhint2Inputs */

const en_dropparticipationhint2 = /** @type {(inputs: Dropparticipationhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App and website: after signing up people can join right on the website. App only: the website shows the download buttons.`)
};

const de_dropparticipationhint2 = /** @type {(inputs: Dropparticipationhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch im Web: Nach der Registrierung kann man direkt auf der Website mitmachen. Nur in der App: Die Website zeigt die Download-Knöpfe.`)
};

/**
* | output |
* | --- |
* | "App and website: after signing up people can join right on the website. App only: the website shows the download buttons." |
*
* @param {Dropparticipationhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropparticipationhint2 = /** @type {((inputs?: Dropparticipationhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropparticipationhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropparticipationhint2(inputs)
	return de_dropparticipationhint2(inputs)
});
export { dropparticipationhint2 as "dropParticipationHint" }